import { useAutocompleteSource } from '@eas/common-web';
import { AbsenceTypeAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useAbsenceTypes() {
  return useAutocompleteSource<AbsenceTypeAutocomplete>({
    url: `${EvidenceApiUrl.ABSENCE_TYPES}/autocomplete`,
  });
}
